import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@mykanban/server/router';

// Type-safe tRPC клиент. AppRouter импортируется только как тип
// через subpath export `@mykanban/server/router` (без runtime-зависимости).
export const api = createTRPCReact<AppRouter>();
